import { BACK_TO_COMPANIES } from './companyTypes'
import {
    handleCompanyLoading,
    handleCompanyHistoryLoading,
    handleCompanyAuditLoading,
    handleCompanySettingsLoading,
    handleUpdateSuccess,
    handleExcludeSuccess,
    companyListLoaded,
    handleSyncCompanyLoadingToggle,
    companyCredentialsValidated,
    companyDetailsLoaded,
    setupCompanyListLoaded,
    unsyncedListLoaded,
    agreementListLoaded,
    handleUpdateSelectedCompany,
    addSaveToast,
    addWarningToast,
    addDeleteToast,
    addErrorToast,
    companyHistoryLoaded,
    companyAuditLoaded,
    companySettingsLoaded,
} from './companyActionCreators'

import api from '../../services/api'
import { push } from 'connected-react-router'

export const fetchUnsyncedCompanyList = () => async (dispatch) => {
    dispatch(handleCompanyLoading())

    try {
        const res = await api.get(`/company/unsynced`)
        const data = await res.json()

        dispatch(unsyncedListLoaded(data))
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const fetchCompanyList = () => async (dispatch) => {
    dispatch(handleCompanyLoading())

    try {
        const res = await api.get(`/company/companies`)
        const data = await res.json()

        dispatch(companyListLoaded(data))
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const handleSyncNow = (id) => async (dispatch) => {
    dispatch(handleSyncCompanyLoadingToggle())

    try {
        const res = await api.post(`/sync/${id}`)
        if (res.ok) {
            dispatch(fetchConfiguredCompanyList(true))
            dispatch(fetchCompanyDetails(id, true, 1, 10, null, null, null))
            dispatch(addSaveToast('sync'))
            dispatch(handleSyncCompanyLoadingToggle())
        } else {
            dispatch(addErrorToast(res.status))
            dispatch(handleSyncCompanyLoadingToggle())
        }
    } catch (e) {
        dispatch(handleSyncCompanyLoadingToggle())
        dispatch(addErrorToast(e))
    }
}

export const handleSaveCompanySettings = (id, values, isAdmin) => async (dispatch) => {
    dispatch(handleSyncCompanyLoadingToggle())

    try {
        values = { ...values };
        delete values.directoryIdHasChanged;
        values.domains = values.domains.map(d => {
            let domain = { ...d };
            domain.exclusionExpires = domain.exclusionExpires !== null ? new Date(d.exclusionExpires).toISOString() : null;

            return domain;
        });
        if(!isAdmin){
            values = values.domains;
        }
        const res = await api.post(`/company/${id}/${isAdmin ? "settings" : "managersettings"}`, values)
        if (res.ok) {
            dispatch(addSaveToast('settings'))
            dispatch(fetchCompanyDetails(id, true, 1, 10, null, null, null))
            dispatch(handleSyncCompanyLoadingToggle())
        } else {
            dispatch(addErrorToast(res.statusText))
            dispatch(handleSyncCompanyLoadingToggle())
        }
    } catch (e) {
        dispatch(addErrorToast(e))
        dispatch(handleSyncCompanyLoadingToggle())
    }
}

export const fetchCompanyDetails = (id, reload, page, pageSize, sortField, sortOrder, filters) => async (dispatch) => {
    if (reload) {
        dispatch(handleCompanyLoading())
    }
    var userQuery = `/company/${id}/users?page=${page}&pageSize=${pageSize}`

    if (sortField !== null && sortField !== undefined) {
        userQuery += `&sortField=${sortField}&sortOrder=${sortOrder}`
    }

    let filterArray = null
    if (filters !== null && filters !== undefined) {
        // filters needs to create an object for each key and add it to an array
        filterArray = Object.entries(filters).map(([k, v]) => ({ fieldName: k, data: v }))
    }

    try {
        const [userRes, companiesRes] = await Promise.all([
            api.post(userQuery, { filters: filterArray }),
            api.get(`/company/companies/configured`),
        ])

        const userList = await userRes.json()
        const companies = await companiesRes.json()

        dispatch(
            companyDetailsLoaded({
                users: userList.users,
                userCount: userList.count,
                excludedAdditions: userList.excludedAdditions,
                companies: companies,
                selectedCompanyId: id,
            })
        )
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const fetchCompanySettings = (id, reload, isAdmin) => async (dispatch) => {
    if (reload) {
        dispatch(handleCompanySettingsLoading())
    }

    try {
        const res = await api.get(`/company/${id}/${isAdmin ? "settings" : "managersettings"}`)
        let settings = await res.json()

        if(!isAdmin){
            settings = {
                id,
                domains: settings
            };
        }
        settings.domains.forEach(d => d.exclusionExpires = d.exclusionExpires !== null ? +new Date(d.exclusionExpires) : null);

        dispatch(companySettingsLoaded({ settings: settings }))
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const fetchCompanyHistory = (id, reload, page, pageSize) => async (dispatch) => {
    if (reload) {
        dispatch(handleCompanyHistoryLoading())
    }

    try {
        const res = await api.get(`/company/${id}/history?page=${page}&pageSize=${pageSize}`)
        const history = await res.json()

        dispatch(companyHistoryLoaded({ history: history.history, historyCount: history.count }))
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const fetchCompanyAudit = (id, reload, page, pageSize, searchFilter) => async (dispatch) => {
    if (reload) {
        dispatch(handleCompanyAuditLoading())
    }

    try {
        let query = `/company/${id}/audit?page=${page}&pageSize=${pageSize}`
        if (searchFilter !== null && searchFilter !== undefined) {
            query = `/company/${id}/audit?page=${page}&pageSize=${pageSize}&searchFilter=${searchFilter}`
        }
        const res = await api.get(query)
        const audit = await res.json()

        dispatch(companyAuditLoaded({ audit: audit.auditLogs, auditCount: audit.count }))
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const fetchConfiguredCompanyList = (reload) => async (dispatch) => {
    if (reload) {
        dispatch(handleCompanyLoading())
    }

    try {
        const res = await api.get(`/company/companies/configured`)
        const data = await res.json()

        dispatch(setupCompanyListLoaded(data))
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const fetchAgreementList = (company) => async (dispatch) => {
    dispatch(handleCompanyLoading())

    try {
        const res = await api.get(`/company/companies/${company.value}/agreements`)
        const data = await res.json()

        dispatch(agreementListLoaded(data))
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const handleDeleteCompany = (id) => async (dispatch) => {
    dispatch(handleCompanyLoading())

    try {
        const res = await api.deleteCall(`/company/${id}`)
        if (res.ok) {
            dispatch(fetchConfiguredCompanyList(true))
            dispatch(addDeleteToast('company'))
            dispatch(push(`/Companies`))
        } else {
            dispatch(addErrorToast('deleteCompany'))
        }
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const handleDetailsClick = (id) => async (dispatch) => {
    dispatch(handleUpdateSelectedCompany(id))
    dispatch(push(`/Companies/${id}/Details`))
}

export const showLoginDetails = () => async (dispatch) => {
    dispatch(push('/Create/Details'))
}

export const handleBackToCompanies = () => async (dispatch) => {
    dispatch(push('/Companies'))
    return {
        type: BACK_TO_COMPANIES,
    }
}

export const handleExcludeAccountStatus = (newValue, rowId, companyId) => async (dispatch, getState) => {
    try {
        const res = await api.post(`/company/${companyId}/update/${rowId}/Exclude`, newValue)
        if (res.ok) {
            let payload = {
                newValue: newValue,
                rowId: rowId,
            }
            dispatch(handleExcludeSuccess(payload))
            dispatch(addSaveToast('user'))
        } else {
            let error = await res.json();
            if (error.error === "Base MSA Product must be excluded") {
                dispatch(addWarningToast("You can only exclude the base MSA Product if all other additions are also excluded."))
            }
            else {
                dispatch(addErrorToast(res.statusText))
            }
        }
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const handleUpdateAccountStatus = (newValue, rowId, companyId) => async (dispatch, getState) => {
    try {
        const res = await api.post(`/company/${companyId}/update/${rowId}/Billing`, newValue)

        if (res.ok) {
            let payload = {
                newValue: newValue,
                rowId: rowId,
            }
            dispatch(handleUpdateSuccess(payload))
            dispatch(addSaveToast('user'))
        } else {
            dispatch(addErrorToast(res.statusText))
        }
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const handleSubmitCreateCompanyDetails = (values) => async (dispatch, getState) => {
    dispatch(handleCompanyLoading())

    try {
        const { company } = getState()

        values.ConnectWiseCompanyId = company.createSelected.value
        values.ConnectWiseCompanyName = company.createSelected.label
        values.AgreementId = company.selectedAgreement.value

        const res = await api.post(`/company/register`, values)

        if (res.ok) {
            const data = await res.json()
            const { companyId, userCount } = data
            dispatch(companyCredentialsValidated(userCount))
            dispatch(push(`/Companies/${companyId}/Details`))
        } else {
            dispatch(addErrorToast(res.status))
            throw await res.text()
        }
    } catch (e) {
        dispatch(addErrorToast(e))
        throw e
    }
}

export const handleShowCompanyDetails = (company) => async (dispatch) => {
    dispatch(push(`/Companies/${company}/Details`, { isNew: true }))
}